// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file common/v1/pagination.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file common/v1/pagination.proto.
 */
export const file_common_v1_pagination: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chpjb21tb24vdjEvcGFnaW5hdGlvbi5wcm90bxIJY29tbW9uLnYxIuEBChNQYWdpbmF0aW9uQXJndW1lbnRzEhIKBWFmdGVyGAEgASgJSACIAQESEwoGYmVmb3JlGAIgASgJSAGIAQESEgoFZmlyc3QYAyABKAVIAogBARIRCgRsYXN0GAQgASgFSAOIAQESJAoFb3JkZXIYBSABKA4yEC5jb21tb24udjEuT3JkZXJIBIgBARIVCghvcmRlcl9ieRgGIAEoCUgFiAEBQggKBl9hZnRlckIJCgdfYmVmb3JlQggKBl9maXJzdEIHCgVfbGFzdEIICgZfb3JkZXJCCwoJX29yZGVyX2J5IpoBChJQYWdpbmF0aW9uUGFnZUluZm8SFQoNaGFzX25leHRfcGFnZRgBIAEoCBIZChFoYXNfcHJldmlvdXNfcGFnZRgCIAEoCBIZCgxzdGFydF9jdXJzb3IYAyABKAlIAIgBARIXCgplbmRfY3Vyc29yGAQgASgJSAGIAQFCDwoNX3N0YXJ0X2N1cnNvckINCgtfZW5kX2N1cnNvcio9CgVPcmRlchIVChFPUkRFUl9VTlNQRUNJRklFRBAAEg0KCU9SREVSX0FTQxABEg4KCk9SREVSX0RFU0MQAmIGcHJvdG8z'
  )

/**
 * Cursor pagination arguments to provide both forward and backward pagination
 *
 * Use the first/after arguments to paginate forward
 * Use the last/before arguments to paginate backward
 *
 * @generated from message common.v1.PaginationArguments
 */
export type PaginationArguments = Message<'common.v1.PaginationArguments'> & {
  /**
   * Paginate after is an opaque cursor that includes any records immediately after sorted by the order field returning at most "first" records.
   * This cursor generally comes from the "end_cursor" response string in PaginationPageInfo
   *
   * @generated from field: optional string after = 1;
   */
  after?: string

  /**
   * Paginate before is an opaque cursor that includes any records immediately before the cursor sorted by the order field returning at most "last" records.
   * This cursor generally comes from the "start_cursor" response string in PaginationPageInfo
   *
   * @generated from field: optional string before = 2;
   */
  before?: string

  /**
   * Paginate first takes a non-negative integer
   *
   * Use this argument to indicate how many records you would like to request
   *
   * @generated from field: optional int32 first = 3;
   */
  first?: number

  /**
   * Paginate last takes a non-negative integer
   *
   * Use this argument to indicate how many records you would like to request
   *
   * @generated from field: optional int32 last = 4;
   */
  last?: number

  /**
   * Order direction
   *
   * @generated from field: optional common.v1.Order order = 5;
   */
  order?: Order

  /**
   * Which field to order by
   *
   * @generated from field: optional string order_by = 6;
   */
  orderBy?: string
}

/**
 * Describes the message common.v1.PaginationArguments.
 * Use `create(PaginationArgumentsSchema)` to create a new message.
 */
export const PaginationArgumentsSchema: GenMessage<PaginationArguments> =
  /*@__PURE__*/
  messageDesc(file_common_v1_pagination, 0)

/**
 * Response object used to inform the next pagination arguments
 *
 * @generated from message common.v1.PaginationPageInfo
 */
export type PaginationPageInfo = Message<'common.v1.PaginationPageInfo'> & {
  /**
   * Indicates whether more data exists following the set defined by the clients arguments
   *
   * @generated from field: bool has_next_page = 1;
   */
  hasNextPage: boolean

  /**
   * Indicates whether more data exists prior to the set defined by the clients argument
   *
   * @generated from field: bool has_previous_page = 2;
   */
  hasPreviousPage: boolean

  /**
   * Opaque cursor corresponding to the first record in the response array
   *
   * @generated from field: optional string start_cursor = 3;
   */
  startCursor?: string

  /**
   * Opaque cursor corresponding to the last record in the response array
   *
   * @generated from field: optional string end_cursor = 4;
   */
  endCursor?: string
}

/**
 * Describes the message common.v1.PaginationPageInfo.
 * Use `create(PaginationPageInfoSchema)` to create a new message.
 */
export const PaginationPageInfoSchema: GenMessage<PaginationPageInfo> =
  /*@__PURE__*/
  messageDesc(file_common_v1_pagination, 1)

/**
 * @generated from enum common.v1.Order
 */
export enum Order {
  /**
   * @generated from enum value: ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: ORDER_DESC = 2;
   */
  DESC = 2
}

/**
 * Describes the enum common.v1.Order.
 */
export const OrderSchema: GenEnum<Order> = /*@__PURE__*/ enumDesc(file_common_v1_pagination, 0)
